// Import the global requirements
import React, { useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { checkSessionStatus, checkIfLoggedIn, setCookie, getCookie } from "@wantable/Shared"

import { Menu } from '@wantable/Menu'

// declare the id of the element to be used where the component will be rendered
const rootEl = document.getElementById('headless-slidemenu')

const root = createRoot(rootEl)

const MenuWrapper = () => {
  const [loggedIn, setLoggedIn] = useState(false)
  const [selectedMenu, setSelectedMenu] = useState(getCookie('menu-selected') || "Womens")

  window.addEventListener('token stored', () => {
    setLoggedIn(checkIfLoggedIn())
  })

  const performSwitch = (target, category) => {
     if (target.classList.contains('active')) {
       setSelectedMenu(category)
       setCookie('menu-selected', category)
     }
  }

  const menuSwitcher = () => {
    document.addEventListener('click', (e) => {
      const target = e.target

      if ((target.getAttribute('data-testid') === 'womens-menu')) {
        performSwitch(target, "Womens")
      } else if ((target.getAttribute('data-testid') === 'mens-menu')) {
        performSwitch(target, "Mens")
      }
    })
  }

  useEffect(() => {
    setLoggedIn(checkIfLoggedIn())
  }, [])

  useEffect(() => {
    menuSwitcher()
  }, [selectedMenu])

  return (
    <Menu
      isLoggedIn={loggedIn}
      selectedMenu={selectedMenu}
    />
  )
}

rootEl && root.render(<MenuWrapper />)
